interface CsrfHeader {
    'X-CSRF-Token': string;
}

class CsrfTokenError extends Error {}

/**
 * Reads the CSRF token from the DOM metadata and wraps it in a header to include in an Ajax request.
 * @return {CsrfHeader} the header to send
 * @throws {CsrfTokenError} if no CSRF token is found
 */
export const addCsrfHeader = (): CsrfHeader => {
    const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (!token) {
        throw new CsrfTokenError('Internal error: No CSRF token set');
    }
    return {
        'X-CSRF-Token': token,
    };
};
